// extracted by mini-css-extract-plugin
export default {"rxClosingTimerTitle":"EmWbEy","rxClosingTimerTicker":"vrwkYf"};